const nftNamePrefix = "EV"
export const beforeMintEVNftName = nftNamePrefix;
export const generateAfterMintEVNftName = (id: number): string => nftNamePrefix + "#" + String(id).padStart((4), "0");